"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TextField = function TextField(_ref) {
  var id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      type = _ref.type,
      helperText = _ref.helperText,
      error = _ref.error,
      value = _ref.value,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      isRequired = _ref.isRequired;
  return _react["default"].createElement(_TextField["default"], {
    required: isRequired,
    id: id,
    name: name,
    label: label,
    type: type,
    helperText: helperText,
    error: error,
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    fullWidth: true
  });
};

TextField.propTypes = {
  id: _propTypes["default"].string,
  isRequired: _propTypes["default"].bool,
  name: _propTypes["default"].string,
  label: _propTypes["default"].string,
  type: _propTypes["default"].string,
  helperText: _propTypes["default"].string,
  error: _propTypes["default"].bool,
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func
};
var _default = TextField;
exports["default"] = _default;